var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-table__data"},[_c('Avatar',{attrs:{"username":_vm.columnData.name,"src":_vm.columnData.avatar,"size":30}}),_vm._v(" "+_vm._s(_vm.columnData.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }